import { Button, FormGroup, HTMLSelect } from '@blueprintjs/core'
import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setCurrentPrinter } from '../../../current/actions'
import qz from '../../../printing/qz'
import { AppState } from '../../../store'

const PrinterList: React.FC = () => {
  const dispatch = useDispatch()
  const { currentPrinter, connected } = useSelector((s: AppState) => ({
    currentPrinter: s.current.currentPrinter,

    connected: s.current.qzConnection.connected
  }))
  const [loading, setLoading] = React.useState(false)
  const [list, setList] = React.useState([])

  const retrieveList = async () => {
    if (!connected) return

    setLoading(true)
    try {
      const printers = await qz.printers.find()
      setList(printers.sort())
    } catch (error) {
      console.log(error)
    }
    setLoading(false)
  }

  React.useEffect(() => {
    retrieveList()
  }, [])

  return (
    <>
      <FormGroup label="Label printer" disabled={loading || !connected} helperText="We support Dymo and Zebra printers">
        <HTMLSelect
          value={currentPrinter}
          disabled={loading || !connected}
          onChange={e => dispatch(setCurrentPrinter(e.target.value))}
        >
          <option value="">No printer selected</option>
          {list.map(p => (
            <option key={p} value={p}>
              {p}
            </option>
          ))}
        </HTMLSelect>
        {!loading && <Button onClick={retrieveList} minimal icon="refresh" />}
      </FormGroup>
    </>
  )
}

export default PrinterList
